import { ReferenceDot, Label } from 'recharts';

type Props = {
  x: string | number;
  y: string | number;
  value: string;
  dy?: number;
  dx?: number;
};

export function CustomReferenceDot({ x, y, value, dy = 0, dx = 0 }: Props) {
  return (
    <ReferenceDot
      x={x}
      y={y}
      r={4}
      fill="#ffffff"
      stroke="#3b3b3b"
      strokeWidth={3}
    >
      <Label
        value={value}
        position="top"
        dy={dy}
        dx={dx}
        fill="#888888"
        fontSize={12}
        fontWeight="bold"
      />
    </ReferenceDot>
  );
}
